
import { z } from "zod";

export const betaFormSchema = z.object({
  firstName: z.string({
    message: "Voornaam is verplicht",
  }).min(2, "Voornaam moet minimaal 2 karakters zijn"),
  lastName: z.string({
    message: "Achternaam is verplicht",
  }).min(2, "Achternaam moet minimaal 2 karakters zijn"),
  email: z.string({
    message: "E-mailadres is verplicht",
  }).email("Ongeldig e-mailadres"),
  phone: z.string({
    message: "Telefoonnummer is verplicht",
  }).min(10, "Telefoonnummer moet minimaal 10 cijfers zijn"),
  company: z.string({
    message: "Bedrijfsnaam is verplicht",
  }).min(2, "Bedrijfsnaam moet minimaal 2 karakters zijn"),
  industry: z.string({
    message: "Sector is verplicht",
  }).min(2, "Sector moet minimaal 2 karakters zijn"),
  companySize: z.string({
    message: "Aantal medewerkers is verplicht",
  }).min(1, "Aantal medewerkers is verplicht"),
  currentLeadGenMethod: z.string().optional(),
  motivation: z.string({
    message: "Motivatie is verplicht",
  }).min(10, "Motivatie moet minimaal 10 karakters zijn"),
  privacyAccepted: z.boolean({
    message: "Je moet akkoord gaan met het privacybeleid",
  }).refine(val => val === true, {
    message: "Je moet akkoord gaan met het privacybeleid"
  }),
  website: z.string().optional(), // honeypot field
});

export type BetaFormValues = z.infer<typeof betaFormSchema>;
